import * as React from 'react';

export interface MenuCoordinates {
  x: number;
  y: number;
}

interface PopoverContainerProps extends React.ComponentPropsWithRef<'div'> {
  anchorPoint: MenuCoordinates | null;
}

function PopoverContainer(props: PopoverContainerProps, ref: React.ForwardedRef<HTMLDivElement>) {
  const { children, anchorPoint, ...other } = props;

  return (
    <div
      ref={ref}
      style={{
        position: 'fixed',
        top: anchorPoint?.y,
        left: anchorPoint?.x,
      }}
      data-pressed={!!anchorPoint || undefined}
      {...other}
    >
      {children}
    </div>
  );
}

const _PopoverContainer = React.forwardRef<HTMLDivElement, PopoverContainerProps>(PopoverContainer);

export { _PopoverContainer as PopoverContainer };
export type { PopoverContainerProps };
